import { either } from 'fp-ts';
import { Decoder } from 'io-ts/Decoder';

export const optionalDecoder = <I, A>(or: Decoder<I, A>): Decoder<undefined | I, undefined | A> => ({
	decode: (i) => (i === undefined ? either.right(undefined) : or.decode(i)),
});
